











import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import Footer from "@/components/Footer.vue";
import RegisterForm from "@/components/forms/RegisterForm.vue";

@Component({
  components: {
    Header,
    Footer,
    RegisterForm,
  },
})
export default class URegister extends Vue {}
